import { createSlice } from "@reduxjs/toolkit";
import { ONBOARD_CLIENT } from "../constants";

export const onboardClientSlice = createSlice({
  name: ONBOARD_CLIENT,
  initialState: {},
  reducers: {
    addClientData: (state, action) => {
      const data = {
        ...state,
        ...action.payload,
      };

      return (state = data);
    },
    removeClientData: (state, action) => {
      return (state = {});
    },
    clearReduxData: (state, action) => {
      let newData = keyExtractor(action.payload);
      
      const data = {
        ...state,
        ...newData,
      };
      return data;
    },
  },
});

const keyExtractor = (obj) => {
  let newObj = {};
  Object.keys(obj)?.map((val) => {
    newObj[val] = "";
  });
  return newObj;
};
export const { addClientData, removeClientData, clearReduxData } =
  onboardClientSlice.actions;

export default onboardClientSlice.reducer;
